import _ from "lodash";

const CalcValueHandler = {
  checkbox(widget_value, field) {
    var maxScore = Math.max(
      Number(field.params.yesScore),
      Number(field.params.noScore),
      Number(field.params.naScore)
    );
    var minScore = Math.min(
      Number(field.params.yesScore),
      Number(field.params.noScore),
      Number(field.params.naScore)
    );
    if (!field.params.allow_na) {
      maxScore = Math.max(
        Number(field.params.yesScore),
        Number(field.params.noScore)
      );
      minScore = Math.min(
        Number(field.params.yesScore),
        Number(field.params.noScore)
      );
    }

    if (widget_value === true)
      return {
        value: Number(field.params.yesScore) || 1,
        max: Number(maxScore),
        min: Number(minScore),
      };
    if (widget_value === false)
      return {
        value: Number(field.params.noScore) || -1,
        max: Number(maxScore),
        min: Number(minScore),
      };
    if (widget_value === null)
      return {
        value: Number(field.params.naScore) || 0,
        max: Number(maxScore),
        min: Number(minScore),
      };
  },
  section(widget_value, field) {
    return calculate_all_fields(widget_value || {}, field.fields);
  },
  number(widget_value, field) {
    return {
      value: Number(widget_value),
      max: Number(field.params.max),
      min: Number(field.params.min),
    };
  },
  select(widget_value, field) {
    var maxScore = Number(
      (_.maxBy(field.params.options, "value") || { value: 0 }).value
    );
    var minScore = Number(
      (_.minBy(field.params.options, "value") || { value: 0 }).value
    );

    return { value: Number(widget_value), max: maxScore, min: minScore };
  },
  formula(widget_value, field) {
    // what is the min/max here ? Not sure...
    return {
      value: Number(widget_value),
      max: Number.MAX_VALUE,
      min: Number.MIN_VALUE,
    };
  },
};

function calculate_all_fields(item, fields) {
  var max = 0;
  var min = 0;
  var total = 0;

  const result = {};
  _.forEach(fields, function (field) {
    if (field.has_score) {
      const widget_value = item[field.code];

      const handler = CalcValueHandler[field.field_type];

      if (handler) {
        var score = handler(widget_value, field);

        if (score) {
          max = max + score.max;
          if (score.min < min) {
            min = score.min;
          }
          score.percentage =
            ((score.value - score.min) / (score.max - score.min)) * 100;
          total = total + score.value;

          result[field.code] = score;
        }
      }
    }
  });

  return {
    value: total,
    min: min,
    max: max,
    percentage: ((total - min) / (max - min)) * 100,
    children: result,
  };
}

export default function (item, fields) {
  return calculate_all_fields(item || {}, fields);
}
